<!-- [コンテンツ領域] -->
<div class="l-core-contents__inner">
  <!-- [コンテンツ領域カラム−メイン] -->
  <div class="l-core-contents__main">
    <div class="l-section">
      <div class="p-organization-select">
        <!-- フィルタボタン -->
        <ng-container *ngIf="!isSp">
          <div class="p-result-function__block">
            <div class="p-result-function__item">
              <button
                id="organization-select-press-pc-filter-btn"
                class="p-result-function__btn p-result-function__btn--filter"
                (throttleClick$)="clickFilterButton()"
                aswThrottleClick
              >
                <span class="p-result-function__btn-text" [innerHTML]="'label.filterBotton' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
        <!-- フィルタ条件 -->
        <div class="p-organization-select__filter-condition">
          <ng-container *ngIf="filterContractSecName || filterCompanyAccountCode">
            <h3
              class="p-organization-select__filter-condition-title"
              [innerHTML]="'m_static_message-label.filtered' | staticMsg"
            ></h3>
            <span class="p-organization-select__filter-condition-body">
              <ng-container *ngIf="filterContractSecName">
                <span
                  [innerHTML]="'m_static_message-label.filteredOrganizationId' | staticMsg"
                  [innerHTML]="
                    'm_static_message-label.filteredOrganizationName' | staticMsg : { '0': filterContractSecName }
                  "
                ></span>
              </ng-container>
              <ng-container *ngIf="filterContractSecName && filterCompanyAccountCode">
                <span [innerHTML]="'m_static_message-label.filteredDelimiter' | staticMsg"> </span>
              </ng-container>
              <ng-container *ngIf="filterCompanyAccountCode">
                <span
                  [innerHTML]="
                    'm_static_message-label.filteredOrganizationId' | staticMsg : { '0': filterCompanyAccountCode }
                  "
                ></span>
              </ng-container>
            </span>
          </ng-container>
          <ng-container *ngIf="!(filterContractSecName || filterCompanyAccountCode)">
            <span [innerHTML]="'m_static_message-label.notFiltered' | staticMsg"> </span>
          </ng-container>
        </div>

        <!-- 組織一覧 -->
        <div class="p-organization-select__list" *ngFor="let item of perPageData">
          <a
            id="organization-select-pres-link-1"
            class="p-organization-select__list-item"
            (throttleClick$)="
              clickListItem(
                item.companyAccountCode,
                aswLangCode === 'ja' ? item.contractSectionName : item.contractSectionEnglishName
              )
            "
            *ngIf="item.companyAccountCode"
            aswThrottleClick
          >
            <div class="p-organization-select__list-item--body">
              <!-- 契約状態 -->
              <span
                [class]="'p-organization-select__status-' + item.contractStatus"
                [innerHTML]="
                  item.contractStatus && contractStatusMsg[item.contractStatus]
                    ? (contractStatusMsg[item.contractStatus] | staticMsg)
                    : ''
                "
              ></span>
              <!-- 組織名 -->
              <h3 class="p-organization-select__organization-name">
                {{ aswLangCode === 'ja' ? item.contractSectionName : item.contractSectionEnglishName }}
              </h3>
              <!-- 組織ID -->
              <span
                class="p-organization-select__organization-id"
                [innerHTML]="'label.organizationId' | staticMsg"
              ></span>
              {{ item.companyAccountCode }}
            </div>
          </a>
        </div>

        <!-- ページネーション -->
        <div class="p-organization-select__pagination">
          <!-- 表示数 -->
          <span>{{ displayNumber }}</span>

          <span class="p-organization-select__pagination-body">
            <!-- 前へボタン -->
            <button
              id="organization-select-on-prev"
              class="p-organization-select__pagination-body--prev-button"
              (throttleClick$)="onPrev()"
              [disabled]="currentPage === 1"
              [attr.aria-label]="'reader.previousPage' | staticMsg"
              aswThrottleClick
            ></button>
            <!-- ページリンクボタン -->
            <button
              id="organization-select-page-link"
              *ngFor="let number of pageNumbers"
              (throttleClick$)="goToPage(number)"
              [class.active]="number === currentPage"
              aswThrottleClick
            >
              <div id="organization-select-page-link-1" style="margin: 0 10px">
                {{ number }}
              </div>
            </button>
            <!-- 次へボタン -->
            <button
              id="organization-select-on-next"
              class="p-organization-select__pagination-body--next-button"
              (throttleClick$)="onNext()"
              [disabled]="currentPage === maxPage"
              [attr.aria-label]="'reader.nextPage' | staticMsg"
              aswThrottleClick
            ></button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- [画面下部固定フローティングナビ] -->
<div *ngIf="isSp" class="l-bottom-float">
  <!-- [下部固定エリア内機能ボタンエリア] -->
  <div class="p-bottom-float-function-icon">
    <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--left01">
      <button
        id="organization-select-filter-sp"
        (click)="clickFilterButton()"
        class="p-bottom-float-function-icon__btn"
        title="{{ 'label.filterBotton' | staticMsg }}"
      >
        <img
          src="assets/images/icon_filter_primary_20.svg"
          width="20"
          height="20"
          alt="{{ 'alt.filterBotton' | staticMsg }}"
        />
      </button>
    </div>
  </div>
</div>
